import type { PermissionHandle } from './types';

const shouldBeIgnored = (match: { id?: string }): boolean =>
  typeof match.id === 'string' &&
  !['root', 'workspace-and-auth', 'layout', 'non-layout', 'page-not-found'].includes(match.id);

export const findPermissionHandle = (
  matches: {
    id?: string;
    handle?: unknown;
  }[],
): PermissionHandle | undefined => {
  const filteredMatches = matches
    .filter(shouldBeIgnored)
    .reverse()
    .find(
      (m) =>
        typeof m.handle === 'object' &&
        m.handle !== null &&
        ('allowAnonymous' in m.handle ||
          'allowPrincipal' in m.handle ||
          'allowAgent' in m.handle ||
          'allowCompanyAdmin' in m.handle ||
          'allowAuthenticated' in m.handle ||
          'allowAgentAdmin' in m.handle ||
          'extraCondition' in m.handle),
    ) as { handle: PermissionHandle } | undefined;

  return filteredMatches?.handle;
};

export const checkIfRouteIsAllowed = (
  matches: Parameters<typeof findPermissionHandle>[0],
  authState: { isUserAnonymous: boolean; isUserPrincipal: boolean; isUserAgent: boolean },
  userRole: { isAdmin: boolean },
): boolean => {
  const authHandle = findPermissionHandle(matches);
  if (!authHandle) {
    return true;
  }
  const { isUserAgent, isUserAnonymous, isUserPrincipal } = authState;
  const { isAdmin } = userRole;

  if (authHandle.allowAnonymous && isUserAnonymous) return true;
  if (authHandle.allowAgent && isUserAgent) return true;
  if (authHandle.allowPrincipal && isUserPrincipal) return true;
  if (authHandle.allowCompanyAdmin && isAdmin) return true;
  if (authHandle.allowAuthenticated && !isUserAnonymous) return true;
  if (authHandle.allowAgentAdmin && isUserAgent && isAdmin) return true;

  return false;
};
